import React from "react";
import InteriorHolding from "./components/InteriorHolding";

function App() {
  return (
    <div className="App">
      <InteriorHolding />
    </div>
  );
}

export default App;